import React, { Component } from 'react';
import isPast from 'date-fns/is_past'
import _ from 'lodash';
import { isLive} from '~/tools/mll/helpers';
import SportBanner from './SportBanner';
import SharingFooter from '~/modules/Article/sharingFooter';
import './index.css';

class SportComponent extends Component {
  state = {
    selection: true,
  }

  displayTabs = () => {
    this.setState(this.state);
  }

  selection = (e) => {
    if (_.endsWith(e.target.className, 'selected')) {
      return;
    }

    this.setState({
      selection: !this.state.selection
    })
  }

  initializeProps = () => {
    this.setState(this.state)
  }

  componentDidMount = () => {
    if (isPast(this.props.faceoffTime) && 
      isLive(this.props.page.contentType, this.props.api)) {
      this.setState({ selection: false })
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.api !== nextProps.api) {
      this.initializeProps()
    }
  }

  render() {
    const page = this.props.page;
    const api = this.props.api;
    const isEvent = page.contentType === 'EVENT'

    return (
      <div className='game-detail'>
        { this.props.faceoffTime && 
          <SportBanner 
            page={page}
            data={api}
            env={this.props.env}
            displayTabs={this.displayTabs}
            selection={this.state.selection}
            faceoffTime={this.props.faceoffTime}
          /> }
        { isPast(this.props.faceoffTime) ? 
          <div className='page-selection'>  
            <div onClick={this.selection} className={this.state.selection? 'game-preview site-border-color selected' : 'game-preview'}>
              { page.contentType } { isEvent ? 'Recap' : 'Preview' }
            </div>
            <div onClick={this.selection} className={this.state.selection ? 'game-recap' : 'game-recap site-border-color selected'}>
              {page.contentType} { isLive(page.contentType, api) ? ' Live' : isEvent ? ' Cagenomics' : ' Recap' }
            </div>
          </div> : <div /> }
        { this.state.selection ? 
          <this.props.env.preview page={page} api={api}/> : 
          <this.props.env.recap page={page} api={api}/> 
        }
        <SharingFooter 
          path={window.location.href}
          title={page.title}
          type={page.contentType}
        />
      </div>
    )
  }
}

export default SportComponent;